import { createContext, createElement, useContext } from "react";
const TransportContext = createContext(null);
/**
 * TransportProvider puts the one configured transport in context.
 *
 * It is context rather than a module-level singleton so a test can mount a
 * component against a fake transport without monkey-patching fetch, and so a
 * portal can point at a different base URL per deployment without a rebuild
 * of this package.
 */
export function TransportProvider({ transport, children }) {
    return createElement(TransportContext.Provider, { value: transport }, children);
}
export function useTransport() {
    const transport = useContext(TransportContext);
    if (!transport) {
        throw new Error("useTransport: no TransportProvider above this component.");
    }
    return transport;
}
//# sourceMappingURL=transport-context.js.map